<template>
	<div class="itemWrapper">
		<div class="userInfor">
			<div class="avatarWrapper">
				<img class="avatarImg img" :src="data.post_pic" />
			</div>
			<div class="userNameWrapper">
				<div class="userNameText">{{data.post_author}}</div>
				<div class="decorationText">回复了主题</div>
			</div>
			<div class="time"></div>
		</div>
		<div class="titleWrapper">
			<div class="title">{{data.post_message}}</div>
		</div>
		<div class="replyWrapper">
			<div class="replyName">{{data.author}} · {{data.show_time}}</div>
			<div class="replyContent">{{data.title}}</div>
		</div>
		<div class="subItems">
			<div class="time">{{data.post_show_time}}</div>
			<div class="rightItems">
				<div class="subitem">
					<span class="icon"><img class="img" src="@/assets/image/personalCenter/eye.png" alt=""></span>
					<span>{{data.views}}</span>
				</div>
				<div class="subitem">
					<span class="icon"><img class="img" src="@/assets/image/personalCenter/comment.png" alt=""></span>
					<span>{{data.replies}}</span>
				</div>
				<div class="subitem">
					<span class="icon"><img class="img" src="@/assets/image/personalCenter/favor.png" alt=""></span>
					<span>{{data.favtimes}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['data']
}
</script>

<style scoped>
.itemWrapper{
	padding: 10px 15px;
	margin-top: 5px;
	background-color: #fff;
}
.userInfor{
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 5px;
}
.avatarWrapper{
	width: 30px;
	height: 30px;
	overflow: hidden;
	border-radius: 15px;
	border-width: 1px;
	border-color: #fff;
}
.avatarImg{
	object-fit: cover;
}
.userNameWrapper{
	flex: 1;
	margin-left: 7px;
	margin-right: 7px;
}
.userNameText{
	font-size: 14px;
	color: #1d2023;
}
.decorationText{
	margin-top: 3px;
	font-size: 11px;
	color: #606972;
}
.titleWrapper{
	margin-bottom: 10px;
}
.title{
	flex: 1;
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	font-size: 18px;
	font-weight: bold;
	color: #000;
}
.replyWrapper{
	background-color: #f7f8f8;
	margin-bottom: 10px;
	padding: 10px;
}
.replyName{
	color: #4a90e2;
	font-size: 12px;
	margin-bottom: 5px;
}
.replyContent{
	color: #1d2023;
	font-size: 14px;
	padding-left: 10px;
	margin-left: 10px;
	border-left-width: 1px;
	border-left-color: #979797;
}

.subItems{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.rightItems{
	display: flex;
}
.subitem{
	display: flex;
	align-items: center;
	padding-left: 4px;
	padding-right: 4px;
	font-size: 12px;
	color: #606972;
}
.time{
	font-size: 12px;
	color: #606972;
}


.icon{
	display: inline-block;
	width: 19px;
	height: 19px;
	margin-right: 3px;
	flex-shrink: 0;
	overflow: hidden;
}
.icon > img{
	object-fit: contain;
}
.hidden{
	display: none;
	width: 0;
	height: 0;
}
.img{
	width: 100%;
	height: 100%;
}
</style>